import React from 'react'
import Helmet from 'react-helmet'
import marked from 'marked'
var ScrollMagic
if (typeof window === 'object') {
    ScrollMagic = require('scrollmagic')
}

import CustomHelmet from '../components/CustomHelmet'
import Apply from '../components/Apply'
import Afterhero from '../components/Program/Afterhero'
import Hero from '../components/Program/Hero'
import Network from '../components/WhatAboutCollege/Network'
import DINavigation from '../components/WhatAboutCollege/DINavigation'

import Row from '../components/Shared/Row'
import Column from '../components/Shared/Column'
import BannerImage from '../components/Destination/BannerImage'
import FAQ from '../components/WhatAboutCollege/FAQ'
import QuotesWithImages from '../components/WhatAboutCollege/QuotesWithImages'
import Testimonial from '../components/WhatAboutCollege/Testimonial'

// if(typeof window == 'object') {
// 	require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
// }

class WhatAbout extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeNav: '',
            controller: null
        }
        this.links = [
            {name: 'College Opinions', reference: 'opinions'},
            {name: 'How to Defer', reference: 'defer'},
            {name: 'College Partnerships', reference: 'college-network'}
        ]
    }
    componentDidMount() {
        let opinions = document.querySelector('#opinions'),
              defer = document.querySelector('#defer'),
              collegeNetwork = document.querySelector('#college-network'),
              offset = 420;
        this.controller = new ScrollMagic.Controller()
    	this.setState({
        	controller: this.controller
    	})
        setTimeout( () => this.navSceneInit(), 450)
        // this.navSceneInit()
        window.addEventListener('scroll', () => {
            let opinionsTrigger = (opinions.offsetTop - offset),
            deferTrigger = (defer.offsetTop - offset),
            collegeNetworkTrigger = (collegeNetwork.offsetTop - offset)

            console.log('SCROLL ===', opinionsTrigger);
            let doc = document.documentElement,
            top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

            if (top > collegeNetworkTrigger) {
                this.state.activeNav != 'college-network' ? this.setState({activeNav: 'college-network'}) : null
            } else if (top > deferTrigger) {
                this.state.activeNav != 'defer' ? this.setState({activeNav: 'defer'}) : null
            } else if (top > opinionsTrigger) {
                this.state.activeNav != 'opinions' ? this.setState({activeNav: 'opinions'}) : null
            } else {
                this.state.activeNav != '' ? this.setState({activeNav: ''}) : null
            }
        })
    }
	componentWillUnmount() {
        this.state.controller.destroy(true)
        this.controller.destroy(true)
	}
    navSceneInit() {
        var triggerHook = window.innerWidth > 1200 ? .3 - 207 / window.innerHeight : 65 / window.innerHeight
        this.navScene = new ScrollMagic.Scene({
            triggerElement: this.refs.pageNav,
            triggerHook
        })
        .setPin(this.refs.pageNav.children[0])
        .addTo(this.controller)
        // .addIndicators()
    }

    render() {
        const { data: { page, home } } = this.props;
        const seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : ``;

        return (
            <div className="program">
                <CustomHelmet data={ page.seoData } />
                <Hero
                    title={page.title}
                    image={page.heroImage}
                    style={{ zIndex: '2' }}
                />
                <div id="DIPageNav" ref="pageNav">
                    <DINavigation
                        activeNav={this.state.activeNav}
                        callbackRef={ el => this.pagenav = el }
                        links={ this.links }
                    />
                </div>
                <Afterhero
                    text={page.heroSplashText.internal.content}
                />
                <QuotesWithImages
                    id="opinions"
                    items={ page.collegeOpinions }
                />
                <Testimonial
                    testimonials={ page.testimonial }
                />
                <FAQ
                    id="defer"
                    title={ page.faqTitle }
                    questions={ page.faq }
                />
                <Network
                  id="college-network"
                  title={page.partnersSectionTitle}
                  text={page.partnersSectionContent.internal.content}
                  logos={page.partnerLogos}
                />
                <Row id="colleges-w-gap-years">
                    <Column width="8" offsetL="4" tablet="12">
                    <h2 className="h2" style={{ marginBottom: '20px' }}>{ page.collegesWithGapYearsTitle }</h2>
                    <div dangerouslySetInnerHTML={{ __html: marked(page.collegesWithGapYearsContent.internal.content) }} />
                    </Column>
                </Row>
                <Row style={{ zIndex: '10' }} className="bg-grey">
                    <Column width="10" tablet="12" tablet="12" style={{ maxWidth: '1040px', margin: '0 auto 0 auto' }}>
                        <p dangerouslySetInnerHTML={{ __html: marked(page.disclaimer.disclaimer) }} />
                    </Column>
                    { /*<Row className="no-bottom-padding no-side-padding">
                        <Column width="10" tablet="12" style={{ maxWidth: '1040px', margin: '0 auto' }}>
                             <a href={ page.disclaimerLink.link } className="hoverlink">{ page.disclaimerLink.text }</a>
                        </Column>
                    </Row> */ }
                </Row>
                <div className="section" style={{ zIndex: '10', position: 'relative' }}>
                    <div className="banner-wrap">
                        <BannerImage image={ page.bannerImage } />
                    </div>
                </div>
                <Apply
                    title={page.applyTitle}
                    buttonText="Request Info"
                    buttonUrl={ `/#signup` }
                />
            </div>
        );
    }
}

export default WhatAbout

export const query = graphql`
    query whatAboutCollegeQuery {
      page: contentfulWhatAboutCollege {
        seoData {
          id
          pageTitle
          keywords
          pageDescription {
            internal {
              content
            }
          }
          openGraphImage {
            file {
              url
            }
          }
          openGraphDescription {
            openGraphDescription
          }
        }
        title
        heroImage {
          sizes(quality:100, maxWidth:1800) {
            ...GatsbyContentfulSizes_withWebp
          }
          file {
            url
          }
        }
        heroSplashText {
          internal {
            content
          }
        }
        collegeOpinions {
          id
          credit
          quote {
            internal {
              content
            }
          }
          collegeLogo {
            file {
              url
            }
          }
        }
        testimonial {
          title
          quote
          profileImage {
            title
            file {
              url
            }
          }
          videoLink
          link {
            link
            text
          }
        }
        faqTitle
        faq {
          id
          question
          answer {
            internal {
              content
            }
          }
        }
        bannerImage {
          id
          title
          description
          sizes(quality:100, maxWidth:1800) {
              ...GatsbyContentfulSizes_withWebp
          }
          file {
            url
          }
        }
        collegesWithGapYearsTitle
        collegesWithGapYearsContent {
          id
          internal {
            content
          }
        }
        partnersSectionTitle
        partnersSectionContent {
          id
          internal {
            content
          }
        }
        partnerLogos {
          id
          title
          link {
            id
            text
            link
          }
          logo {
            id
            title
            file {
              url
              fileName
              contentType
            }
          }
        }
        disclaimer {
          disclaimer
        }
        disclaimerLink {
          id
          link
          text
        }
        applyTitle
        seoData {
          id
          pageTitle
          pageDescription {
            id
            pageDescription
          }
          keywords
          openGraphTitle
          openGraphDescription {
            id
            openGraphDescription
          }
          openGraphImage {
            id
            file {
              url
              fileName
              contentType
            }
          }
        }
      }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/what-about-college.js